module.exports = __webpack_public_path__ + "static/media/DushyanthaNew.eb5b64bc.jpeg";